import React from 'react';
import ReactDOM from 'react-dom';
import "antd/dist/antd.css";
import './index.css';
import App from './App';
import './components/services/Firebase'


ReactDOM.render(<App />, document.getElementById('root'));